module.exports = __webpack_public_path__ + "static/media/video_4.00c7ca1f.mp4";